import { setCookie } from 'cookies-next';

import type { ConfirmOtpSmsTokenSet } from '@/graphql/hasura/auth';

export const processAuth0Token = (tokenSet: ConfirmOtpSmsTokenSet) => {
  const token = JSON.stringify({
    access_token: tokenSet?.access_token,
    id_token: tokenSet?.id_token,
  });
  setCookie('auth', token, {
    maxAge: tokenSet?.expires_in,
  });
};
